import GoogleLogo from 'icons/partner-logo-google.svg';
import useGoogleOneTap from './useGoogleOneTap';

const Divider = () => (
  <div className="padding-bottom-10px padding-top-10px">
    <div className="google-signup-or overflow-hidden">
      <span>or</span>
    </div>
  </div>
);

const GoogleSignupCta = ({
  googleSignupBaseUrl,
  googleButtonLabel = 'Continue with Google',
  fromPartner = false,
}: {
  googleSignupBaseUrl: string;
  googleButtonLabel: string;
  fromPartner?: boolean;
}) => {
  const showGoogleOneTap = useGoogleOneTap(fromPartner);

  let isSSOButtonDisabled = false;

  const handleGoogleSSOClick = () => {
    if (!isSSOButtonDisabled) {
      window.location.href = googleSignupBaseUrl;
      isSSOButtonDisabled = true;
      setTimeout(() => {
        isSSOButtonDisabled = false;
      }, 5000);
    }
  };

  return (
    <div>
      <>
        {showGoogleOneTap && (
          <div
            id="google-one-tap-ui"
            data-prompt_parent_id="google-one-tap-ui"
            data-testid="google-one-tap-ui-test"
            className="d-flex align-items-center justify-content-center"
          />
        )}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          className="d-flex align-items-center justify-content-center btn btn-secondary google-btn"
          onClick={handleGoogleSSOClick}
          tabIndex={0}
          role="button"
          href="#"
          data-testid="google-btn-test"
        >
          <img alt="" className="img-square-20px" src={GoogleLogo} />
          <strong className="padding-left-5px">{googleButtonLabel}</strong>
        </a>
        <Divider />
      </>
    </div>
  );
};

export default GoogleSignupCta;
